import {get,first} from 'lodash'
const reducer = (state={user:{},group:"",loginState:0,error:{}},action)=>{
    switch(action.type){
        case "SET_USER":
            const users = action.payload;
            console.log("users",user)
            return{
                ...state,
                user:users,
                group:get(users,"groups")[0]
            }
        case "LOGIN_USER_FULFILLED":
            const user = action.payload.data;
            console.log(user, 'users')
            localStorage.setItem("user",JSON.stringify(user));
            console.log('user',user,get(user,"groups")[0])
            return { ...state, loginState: 2, user: action.payload.data,group:get(user,"groups")[0]};
          case "LOGIN_USER_REJECTED":
              console.log("action",action);
            return { ...state, loginState: 3,error:action.payload.response.data };
          case "LOGIN_USER_PENDING":
            return { ...state, getState: 1 };
        default:
            return state;
    }
}

export default reducer;